import { makeStyles } from '@epilot/journey-elements'

export const useStyles = makeStyles({
  container: {
    marginBottom: '12px'
  }
})
